var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CheckboxDesignStyles } from '../../../../atoms/checkbox';
import { Text, TextHtmlTags, TextVariants } from '../../../../atoms/text';
import { CheckboxGroup, CheckboxGroupOrientations } from '../../../../molecules/checkbox-group';
import { Container, ContainerDisplays, ContainerFlexDirections, ContainerFlexGaps } from '../../../../templates/container';
import { FilterIDs } from './types';
// auxiliary
var hasUncheckedOptions = function (data) {
    return data === null || data === void 0 ? void 0 : data.every(function (i) { return !(i === null || i === void 0 ? void 0 : i.checked); });
};
var removeRedundancyByAllOption = function (data) {
    return (data === null || data === void 0 ? void 0 : data.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.id) !== FilterIDs.All; })) || [];
};
var initList = function (data, _a, allProp) {
    var id = _a.id, text = _a.text;
    return allProp
        ? __spreadArray([
            {
                id: id,
                text: text,
                checked: hasUncheckedOptions(data)
            }
        ], removeRedundancyByAllOption(data), true) : removeRedundancyByAllOption(data);
};
// ---
var Filter = function (_a) {
    var title = _a.title, description = _a.description, ariaLabelProp = _a["aria-label"], id = _a.id, name = _a.name, _b = _a.checkboxList, checkboxListProp = _b === void 0 ? [] : _b, allProp = _a.all, allLabel = _a.allLabel, _c = _a.row, row = _c === void 0 ? CheckboxGroupOrientations.Horizontal : _c, errorProp = _a.error, message = _a.message, onChangeProp = _a.onChange;
    var _d = useState(initList(checkboxListProp, { id: FilterIDs.All, text: allLabel }, allProp)), filters = _d[0], setFilters = _d[1];
    var error = useMemo(function () { return errorProp || filters.some(function (f) { return f === null || f === void 0 ? void 0 : f.error; }); }, [errorProp, filters]);
    var onChange = useCallback(function (e, currentIndex) {
        var _a, _b, _c, _d;
        var update = __spreadArray([], filters, true);
        if (!allProp) {
            update[currentIndex] = __assign(__assign({}, update[currentIndex]), { checked: !((_a = update[currentIndex]) === null || _a === void 0 ? void 0 : _a.checked) });
        }
        else {
            var isAll = ((_b = update[currentIndex]) === null || _b === void 0 ? void 0 : _b.id) === FilterIDs.All;
            if (isAll && ((_c = update[currentIndex]) === null || _c === void 0 ? void 0 : _c.checked)) {
                return;
            }
            update[currentIndex] = __assign(__assign({}, update[currentIndex]), { checked: isAll || !((_d = update[currentIndex]) === null || _d === void 0 ? void 0 : _d.checked) });
            if (isAll) {
                update.forEach(function (_, index) {
                    update[index] = __assign(__assign({}, update[index]), { checked: currentIndex === index });
                });
            }
            else {
                update[0] = __assign(__assign({}, update[0]), { checked: hasUncheckedOptions(update) });
            }
        }
        setFilters(update);
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(update, currentIndex);
    }, [allProp, filters, onChangeProp]);
    useEffect(function () {
        if (checkboxListProp === null || checkboxListProp === void 0 ? void 0 : checkboxListProp.length) {
            setFilters(initList(checkboxListProp, { id: FilterIDs.All, text: allLabel }, allProp));
        }
    }, [allLabel, allProp, checkboxListProp]);
    return (React.createElement(CheckboxGroup, { title: (React.createElement(Container, { display: ContainerDisplays.Flex, flexDirection: ContainerFlexDirections.Column, flexGap: ContainerFlexGaps.Size_2 },
            React.createElement(Text, { component: TextHtmlTags.P, variant: TextVariants.H6, content: title }),
            React.createElement(Text, { component: TextHtmlTags.P, variant: TextVariants.Body2, content: description }))), id: id, name: name, checkboxList: filters, row: row, errorHint: error ? message : '', designStyle: CheckboxDesignStyles.Filter, "aria-label": ariaLabelProp || title, onChange: onChange }));
};
export { Filter };
